import { buttonVariants } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { gameVersionToSubdomain } from 'app/frontend/types/custom/GameVersion'
import { useTeam } from 'app/frontend/base/config/context/team'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useCopyToClipboard } from 'app/frontend/base/helpers/hooks'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'app/frontend/base/config/context/auth'
import SheetsUrlInput from './SheetsUrlInput'

const SpreadsheetGetStarted = () => {
  const { team } = useTeam()
  const { t } = useTranslation()
  const {
    data: { gameVersion },
  } = usePageInfo()
  const { copied, copyToClipboard } = useCopyToClipboard()
  const { accessLevel } = useAuth()

  if (accessLevel === 'admin') {
    return (
      <>
        <h5>Get started</h5>
        <div className='flex items-center gap-2 my-4'>
          <a
            href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com/copy`}
            className={buttonVariants()}
            target='_blank'
            rel='noreferrer'
          >
            Make a copy
          </a>
          <a
            href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com/demo`}
            target='_blank'
            rel='noreferrer'
            className={buttonVariants({ variant: 'outline' })}
          >
            View demo
          </a>
        </div>

        <p>
          After making a copy, paste this key in the settings tab of your new
          spreadsheet:
        </p>
        <div className='bg-background rounded-md py-2 px-4 my-3 border border-border'>
          <Tooltip>
            <TooltipTrigger
              onClick={() => copyToClipboard(team.readonlyKey ?? '')}
            >
              <span className='text-lg font-mono'>{team.readonlyKey}</span>
            </TooltipTrigger>
            <TooltipContent>
              {copied ? 'Copied!' : t('dashboard.team.settings.click-to-copy')}
            </TooltipContent>
          </Tooltip>
        </div>

        <p>
          Then, complete the setup by pasting the URL of your new spreadsheet
          here:
        </p>

        <SheetsUrlInput />
      </>
    )
  }

  return (
    <>
      <h5>Get started</h5>
      <p>
        Ask one of your team&apos;s admins to set up a copy of the spreadsheet
        (by visiting this page).
      </p>
    </>
  )
}

export default SpreadsheetGetStarted
